import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FastSendLogo from "./FastSendLogo";

/**
 * Reusable top header bar for User-portal pages.
 *
 * Props:
 *  - walletBalance  (number | null)  — shows wallet chip when provided
 *  - membershipTier (string)         — shows ⭐ PLUS chip when "plus"
 *  - backTo         (string | null)  — shows "← Back" link when provided
 *  - backLabel      (string)         — text for the back link (default "Back")
 */
export default function UserPageHeader({
  walletBalance = null,
  membershipTier = "standard",
  backTo = null,
  backLabel = "Back",
}) {
  const { account } = useAuth();

  return (
    <div className="user-page-header" style={{ marginBottom: "20px" }}>
      {/* Left: back link if provided, or FASTSEND brand header */}
      {backTo ? (
        <Link to={backTo} className="user-page-back-link">
          ← {backLabel}
        </Link>
      ) : (
        <Link to="/dashboard" style={{ textDecoration: "none" }}>
          <FastSendLogo variant="horizontal" size="small" showTagline={false} />
        </Link>
      )}

      {/* Right: chips */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {membershipTier === "plus" && (
          <span className="plus-chip">
            ⭐ FASTSEND PLUS
          </span>
        )}
        {walletBalance !== null && (
          <Link to="/wallet" className="wallet-chip">
            💰 ₦{walletBalance.toLocaleString()}
          </Link>
        )}
        {account && (
          <span className="user-page-avatar">
            {account.name?.charAt(0)?.toUpperCase() || "U"}
          </span>
        )}
      </div>
    </div>
  );
}
